export const ROLES = {
  ADMIN: "admin",
  FULL: "benefitTeam",
  REPORTING: "reporting",
  PEOPLE: "peopleOnly",
  LIMITED: "accounting",
  CH_ADMIN: "chAdmin"
};

export const ROLE_DISPLAY_LABELS = {
  [ROLES.ADMIN]: "Administrator",
  [ROLES.FULL]: "Full",
  [ROLES.REPORTING]: "Analytics",
  [ROLES.PEOPLE]: "People",
  [ROLES.LIMITED]: "Documents"
};

export const LOGGING_ACCESS_LEVELS = {
  [ROLES.ADMIN]: "fullPHIAdmin",
  [ROLES.FULL]: "fullPHI",
  [ROLES.REPORTING]: "reporting",
  [ROLES.PEOPLE]: "peopleOnly",
  [ROLES.LIMITED]: "limitedPHI"
};
